<template>
  <div class="container section-p70">
    <div class="row">
      <div class="col">
        <h2 class="title-blue">{{ t("MODULES") }}</h2>
      </div>
    </div>

    <div class="row justify-content-between align-items-center">
      <div class="col-auto">
        <div class="d-flex align-items-center">
          <ToggleSwitch v-model="showArchived" inputId="id-archived-modules"/>
          <label class="ms-2 mb-0" for="id-archived-modules">{{ t("ARCHIVED") }}</label>
        </div>
      </div>
    </div>

    <div class="separator-line mt-3"></div>

    <div class="row">
      <div class="col">
        <modules-table :show-archived="showArchived"
                       :title="t('REGULAR_MIGRATION')"
                       :color="'blue'"
                       :items="itemsRegularMigration"/>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <modules-table :show-archived="showArchived"
                       :title="t('INTERNATIONAL_PROTECTION')"
                       :color="'gray'"
                       :items="itemsIntProtection"/>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <modules-table :show-archived="showArchived"
                       :title="t('TEMPORARY_PROTECTION')"
                       :color="'blue'"
                       :items="itemsTempProtection"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import {injectAxios} from "@/util/inject";
import {useI18n} from "vue-i18n";
import ModulesTable from "@/views/components/tables/ModulesTable.vue";

const {t} = useI18n();
const modules = ref([]);
const showArchived = ref(false);
const axios = injectAxios();

onMounted(async () => {
  await getData();
});

async function getData() {
  const response = await axios.get(`/training`);
  modules.value = response.data;
}

const items = computed(() => {
  return showArchived.value
      ? modules.value
      : modules.value.filter((m) => !m.archived);
});

const itemsIntProtection = computed(() => {
  return items.value.filter((m) => m.rvk);
});

const itemsTempProtection = computed(() => {
  return items.value.filter((m) => m.temp);
});

const itemsRegularMigration = computed(() => {
  return items.value.filter((m) => !m.rvk && !m.temp);
});
</script>
